/* eslint-disable no-lone-blocks */
import './Manga.scss';
import logo from '../../Navbar/Logo_skinny.png';
import {NavLink, useNavigate} from 'react-router-dom';

import Loader from '../../Loader/Loader';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CottageIcon from '@mui/icons-material/Cottage';




const Manga= ({datas, loader}) => {
  
  let navigate = useNavigate();
  
  {/* bien parametrer la route pour eviter les conflits d' id entre les pages (zoom est un composant commun entre tous) */}

  return loader ? (
    <Loader />
  )
  :
  (
    <div className='page'>
     
      <h1 className='page-title'>

    <NavLink
        to='/'
      > <img src={logo}  alt='logo skinny' className='logo_pages-banner'/>
     
    </NavLink>
      
       - Catégorie Manga - </h1>
       <div className="img_container">
      {datas.map((data) => {
        return(
          <NavLink
          to={`/manga/zoom/${data.id}`} >
         <img src={data.url} alt='realistes' className='data_item'/>
         </NavLink>
        )
      })}
       </div>
    <NavLink
    to='/'
    className='page-back'
     > <CottageIcon/>
     
    </NavLink>

    
    <button
      onClick={() => navigate(-1)}
      className='page-back--btn'
      >  <ArrowBackIosNewIcon/> 
    </button>

     
  
    </div>

  )
}

export default Manga;